import Vue from 'vue'

const state = {
  tweets:[],
  dataSetName:'none',
  start:0
}

export default state



/** WEBPACK FOOTER **
 ** ./src/state.js
 **/